export default "__VITE_ASSET__HXlypp7d__"